import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  getTableColumnNames, 
  GetAllUserTypesAPI, 
  ActivateDeactivateUserTypeAPI, 
  AddUserTypeAPI, 
  UpdateUserTypeAPI, 
  DeleteUserTypesAPI, 
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";


// Fetch UserType Table Column Names
export const fetchUserTypeTableColumnNames = createAsyncThunk(
  "userType/fetchUserTypeTableColumnNames",
  async (params, thunkAPI) => {
    try {
      const response = await getTableColumnNames(params); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Fetch All UserTypes (calls your GetUserType API)
export const fetchAllUserTypes = createAsyncThunk(
  "userType/fetchAllUserTypes",
  async (params, thunkAPI) => { 
    try {
      const response = await GetAllUserTypesAPI(params); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// // Add UserType
// export const addUserType = createAsyncThunk(
//   "userType/addUserType",
//   async (userTypeData, thunkAPI) => {
//     try {
//       const response = await AddUserTypeAPI(userTypeData); // Assumed API call
//       if (response.success) {
//         toast.success(response.message || "UserType added successfully!");
//         return response.data;
//       } else {
//         toast.error(response.message || "Failed to add UserType.");
//         return thunkAPI.rejectWithValue(response);
//       }
//     } catch (error) {
//       toast.error(error.response?.data?.message || error.message || "Something went wrong");
//       return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
//     }
//   }
// );

// // Update UserType
// export const updateUserType = createAsyncThunk(
//   "userType/updateUserType",
//   async (userTypeData, thunkAPI) => {
//   try {
//     const response = await UpdateUserTypeAPI(userTypeData); // Assumed API call
//     if (response.success) {
//       toast.success(response.message || "UserType updated successfully!");
//       return response.data;
//     } else {
//       toast.error(response.message || "Failed to update UserType.");
//       return thunkAPI.rejectWithValue(response);
//     }
//   } catch (error) {
//     toast.error(error.response?.data?.message || error.message || "Something went wrong");
//     return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
//   }
// });

// // Delete UserTypes
// export const deleteUserTypes = createAsyncThunk(
//   "userType/deleteUserTypes",
//   async (userTypeIds, thunkAPI) => {
//   try {
//         const response = await DeleteUserTypesAPI(userTypeIds); // Assumed API call
        
//           toast.success(response.message || "UserType(s) deleted successfully!");
//           return response.data; 
    
//       } catch (error) {
//         toast.error(error.response?.data?.message || error.message || "Something went wrong");
//         return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
//       }
//   }
// );

// // Activate/Deactivate UserType
// export const activateDeactivateUserType = createAsyncThunk(
//   "userType/activateDeactivateUserType",
//   async (userTypeData, thunkAPI) => {
//     try {
//       const response = await ActivateDeactivateUserTypeAPI(userTypeData); // Assumed API call
//       if (response.success) {
//         toast.success(response.message);
//         return response.data; // Assuming API returns the updated userType or relevant data
//       } else {
//         toast.error(response.message);
//         return thunkAPI.rejectWithValue(response.message);
//       }
//     } catch (error) {
//       toast.error("Something went wrong");
//       return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
//     }
//   }
// );